<div class="modal" [id]="dialogId" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" [innerHTML]="question"></h5>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="dialogOnYes()">Tak</button>
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dialogOnNo()">
					Nie
				</button>
			</div>
		</div>
	</div>
</div>
